export function getFullscreenElement() {
  return (
    document.fullscreenElement
    || document.webkitFullscreenElement
    || document.msFullscreenElement
    || null
  );
}

export async function requestElementFullscreen(el) {
  if (!el) return false;
  if (typeof el.requestFullscreen === "function") {
    await el.requestFullscreen();
    return true;
  }
  if (typeof el.webkitRequestFullscreen === "function") {
    await Promise.resolve(el.webkitRequestFullscreen());
    return true;
  }
  if (typeof el.msRequestFullscreen === "function") {
    await Promise.resolve(el.msRequestFullscreen());
    return true;
  }
  return false;
}

export async function exitNativeFullscreen() {
  if (typeof document.exitFullscreen === "function") {
    await document.exitFullscreen();
    return true;
  }
  if (typeof document.webkitExitFullscreen === "function") {
    await Promise.resolve(document.webkitExitFullscreen());
    return true;
  }
  if (typeof document.msExitFullscreen === "function") {
    await Promise.resolve(document.msExitFullscreen());
    return true;
  }
  return false;
}
